export const PUMA_APP_ID = "8502c201-1d4f-4874-9259-ef164c155711";
export const PUMA_MODULE_NAME = "DOLPHIN_INDUCT_";